export default __webpack_public_path__ + "static/typescript-full-3625e9a1611d02cf1eedc7bc217d3172.svg";